import { createAction } from '@reduxjs/toolkit';

import * as types from './types';
import constants from './constants';
import { ValueOf } from '../../globalTypes';

const {
  DEVELOPER_DRAWER_TABS,
} = constants;

const setDeveloperDrawerOpen = createAction<boolean>(types.SET_DEVELOPER_DRAWER_OPEN);
const setDeveloperDrawerHeight = createAction<string>(types.SET_DEVELOPER_DRAWER_HEIGHT);
const setDeveloperDrawerWidth = createAction<string>(types.SET_DEVELOPER_DRAWER_WIDTH);
const setDeveloperDrawerHorizontal = createAction<boolean>(types.SET_DEVELOPER_DRAWER_HORIZONTAL);
const setDeveloperDrawerCurrentTab = createAction<ValueOf<typeof DEVELOPER_DRAWER_TABS>>(
  types.SET_DEVELOPER_DRAWER_CURRENT_TAB,
);

export default {
  setDeveloperDrawerOpen,
  setDeveloperDrawerHeight,
  setDeveloperDrawerWidth,
  setDeveloperDrawerHorizontal,
  setDeveloperDrawerCurrentTab,
};
